import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPipingPlantTypes } from '../../../api/piping-plant-types';

export const getPipingPlantTypesAsync = createAsyncThunk(
  'pipingPlantTypes/getPipingPlantTypes',
  getPipingPlantTypes
);

export interface PipingPlantType {
  id: number;
  name: string;
}

interface PipingPlantTypeState {
  data: PipingPlantType[];
}

const initialState: PipingPlantTypeState = {
  data: []
};

export default createSlice({
  name: 'pipingPlantTypes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPipingPlantTypesAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
  }
});
